import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { PackageResponse } from "src/domain/client";
import { TranslateModule } from "@ngx-translate/core";
import { PackageContainerV2Component } from "../package-container-v2/package-container-v2.component";
import { RadioButtonPackageComponent } from "../radio-button-package/radio-button-package.component";
import { PackageTitleComponent } from "../package-title/package-title.component";
import { PackageDescriptionComponent } from "../package-description/package-description.component";
import { MatRadioGroup } from "@angular/material/radio";

@Component({
    selector: "app-sub-category-package",
    imports: [
        TranslateModule,
        PackageContainerV2Component,
        RadioButtonPackageComponent,
        PackageTitleComponent,
        PackageDescriptionComponent,
        MatRadioGroup,
        ReactiveFormsModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./sub-category-package.component.html"
})
export class SubCategoryPackageComponent {
  package = input<PackageResponse>();
  parentForm = input<FormGroup<any>>();
  toggleSubPackage = signal<boolean>(false);

  subPackageClicked(subPackage: PackageResponse): void {
    const selectedSubPackageValue = this.parentForm()
      .get(this.package().id)
      .get("subcategoryContainer");

    const selectedValue = this.parentForm()
      .get(this.package().id)
      .get("selected");

    if (selectedSubPackageValue.value === subPackage.id) {
      selectedSubPackageValue.setValue(null);
      selectedValue.setValue(null);
      this.toggleSubPackage.set(!this.toggleSubPackage());
    } else {
      selectedSubPackageValue.setValue(subPackage.id);
      selectedValue.setValue(true);
      this.toggleSubPackage.set(!this.toggleSubPackage());
    }
  }
}
